<template>
    <div>
        <div v-if="isGoogleAds" class="popsale-card-item">
            <div class="offer-card mdc-card">
                <div class="mdc-card__primary-action">
                    <ins class="adsbygoogle"
                         style="display:inline-block; width:100%; height:250px"
                         data-ad-client="ca-pub-8273780015068901"
                         data-ad-slot="4108581492"/>
                </div>
            </div>
        </div>
        <div v-else class="popsale-card-item" v-on:click="detail">
            <div class="offer-card mdc-card">
                <div class="corner-ribbon top-left shadow primary-theme" v-if="isAd">廣告</div>

                <div class="mdc-card__primary-action">
                    <div class="mdc-card__media">
                        <img class="cover-photo" :src="this.photourl()"/>
                    </div>

                    <div class="popsale-card__primary" :style="isAd ? 'background-color: #faffd9' : ''">
                        <h2 v-if="!isAd" class="body-title mdc-typography mdc-typography--headline6">{{ mutableCard.name
                            }}</h2>
                        <h2 v-else class="body-title mdc-typography mdc-typography--headline6">{{ mutableCard.title
                            }}</h2>
                    </div>

                    <div class="mdc-card__action" v-if="!isAd">
                        <div style="display: inline-block; width: 25%; font-size: 12px">
                            讚好指數:
                        </div>
                        <div style="display: inline-block; width: 70%">
                            <div class="like-bar">
                                <div class="like-bar__inner" :style="{ width: width + '%' }"></div>
                            </div>
                        </div>
                    </div>

                    <div class="mdc-card__action" v-if="!isAd">
                        <button class="popsale-card-actions mdc-icon-button" v-on:click="promptBlock">
                            <img :src="likePic" class="mdc-icon-button__icon" alt="like"/>
                        </button>
                        <button class="popsale-card-actions mdc-icon-button fa-eye-slash" v-on:click="promptBlock">
                            <img :src="dislikePic" class="mdc-icon-button__icon" alt="dislike"/>
                        </button>
                    </div>

                </div>

                <div v-if="!isAd && isAdmin" class="offer-card__admin-panel">
                    <button id="button-publish" class="mdc-fab mdc-fab--mini" v-on:click="publish">
                    <span v-show="mutableCard.published">
                        <i class="mdc-fab__icon fas fa-eye-slash"></i>
                    </span>
                        <span v-show="!mutableCard.published">
                        <i class="mdc-fab__icon fas fa-eye"></i>
                    </span>
                    </button>

                    <button id="button-edit" class="mdc-fab mdc-fab--mini" v-on:click="edit">
                        <i class="mdc-fab__icon fas fa-edit"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            card: {
                type: Object,
                required: true,
            },
            category: {
                type: Number,
                required: false,
            },
            isAdmin: {
                required: true,
                default: false,
            },
            isGoogleAds: {
                required: true,
                default: false,
            }
        },
        data: function () {
            return {
                'mutableCard': this.card,
                'progressBar': $('.mdc-linear-progress')[0].MDCLinearProgress,
                'snackBar': $('.mdc-snackbar')[0].MDCSnackbar,
                'snackBarText': $('.mdc-snackbar__label'),
                'likePic': '/img/popsale/like.png',
                'dislikePic': '/img/popsale/dislike.png',
                'masonry': $('.card-masonry').masonry(),
                'detailUrl': '../' + this.card.eid,
                'editUrl': '../admin/offers/' + this.card.id + '/edit',
                'publishUrl': '../admin/offer/' + this.card.id + '/publish',
            }
        },
        computed: {
            isAd: function () {
                return this.mutableCard.isAd || false;
            },
            width: function () {
                let total = this.mutableCard.total_likes + this.mutableCard.total_dislikes;
                return this.mutableCard.total_likes / total * 100;
            }
        },
        methods: {
            promptBlock: function (event) {
                event.preventDefault();
                event.stopPropagation();
                window.appDialog.open();
            },
            detail: function () {
                let url = '';
                if (this.isAd) {
                    url = this.mutableCard.action_link;
                } else {
                    url = this.detailUrl;

                    if (this.category) {
                        url += "?c=" + this.category;
                    }
                }

                window.open(url);
            },
            edit: function (event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.editUrl);
            },
            publish: function (event) {
                event.preventDefault();
                event.stopPropagation();

                $.ajax({
                    url: this.publishUrl,
                    beforeSend: function () {
                        this.progressBar.open();
                    }.bind(this),
                    success: function (response) {
                        this.mutableCard = response;
                        this.snackBarText.text(this.responseText(response));
                        this.snackBar.open();
                        this.$forceUpdate();
                    }.bind(this),
                    error: function (error) {
                        this.snackBarText.text("動作失敗,請遲吓再試或者搵相賴嘅人傾吓.");
                        this.snackBar.open();
                    }.bind(this),
                    complete: function () {
                        this.progressBar.close();
                    }.bind(this),
                })
            },
            photourl: function () {
                try {
                    return this.mutableCard.photos[0].url;
                } catch (e) {
                    return '/img/no-pic.png';
                }
            },
            responseText: function (card) {
                return card.published ? '已發佈' : '已隱藏';
            },
        },
        mounted() {
            let $m = this.masonry;
            $m.masonry().append(this.$el).masonry('appended', this.$el);

            if (this.card.photos && this.card.photos.length > 0) {
                $(this.$el).imagesLoaded(function () {
                    $m.masonry('layout');
                });
            } else {
                $m.masonry('layout');
            }

            try {
                (adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {}


            $('.popsale-card-item').hover(function (event) {
                $(event.currentTarget).children().children('.offer-card__admin-panel').css('display', 'flex');
            });

            $('.popsale-card-item').mouseleave(function (event) {
                $(event.currentTarget).children().children('.offer-card__admin-panel').css('display', 'none');
            })
        }
    }
</script>

<style lang="scss">
    .offer-card {
        position: relative;
        overflow: hidden;

        &__admin-panel {
            position: absolute;
            display: none;
            justify-content: center;
            flex-direction: column;
            top: 5px;
            right: 5px;

            .mdc-fab {
                margin-bottom: 5px;

                .mdc-fab__icon {
                    font-size: 0.9em;
                    padding-left: 1px;
                }
            }
        }
    }

    .popsale-card-item {
        margin-bottom: 10px;
    }

    .popsale-card-item .mdc-card {
        margin: 5px;
        width: calc(100% - 10);
    }

    .popsale-card__primary {
        padding: 0 5px;
    }

    .mdc-card-content {
        padding: 16px;
    }

    .cover-photo {
        width: 100%;
        margin: auto;
        cursor: pointer;
    }

    .mdc-card__action .mdc-layout-grid {
        padding: 0;
    }

    .popsale-card-actions.mdc-icon-button img {
        padding-bottom: 5px;
    }

    .body-title {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>